  <div class="filters-toolbar">
    <span class="filters-button">
        <geaui-button-v3 
            [type]="'primary'" 
            class="btn-brdr-radius" 
            preIcon="system-preferences" (click)="this.filterMenuVisible ? closeFilterMenu() : openFilterMenu($event)">
            Filters
        </geaui-button-v3>
      </span>
      <span class="filter-search">
        <mat-form-field class="filter-search-field">
          <mat-label class="gea-blue">Search Projects</mat-label>
          <input
            type="text"
            matInput
            [(ngModel)]="filterSettings.searchText"
            (ngModelChange)="searchTextChanged()"
          />
          <mat-icon
            *ngIf="filterSettings.searchText != ''"
            (click)="filterSettings.searchText = ''; searchTextChanged()"
            matSuffix
            title="Clear search"
            class="gea-blue"
            >close</mat-icon
          >
          <mat-icon matSuffix class="gea-blue">search</mat-icon>
        </mat-form-field>
      </span>
  </div>
  <div class="filter-chips" *ngIf="filterSettings.showResetAll()">
    <span class="filter-chips-label">Filters Applied: </span>
    <mat-chip-set aria-label="Filter selections">
      <mat-chip class="geaui-chip" *ngIf="filterSettings.searchText" removable (removed)="filterSettings.searchText = ''; searchTextChanged()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Search: {{filterSettings.searchText}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.product" removable (removed)="filterSettings.product = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Product: {{formatDisplayValue(filterSettings.product)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.project" removable (removed)="filterSettings.project = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Project: {{formatDisplayValue(filterSettings.project)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.endUser" removable (removed)="filterSettings.endUser = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">End User: {{formatDisplayValue(filterSettings.endUser)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.customer" removable (removed)="filterSettings.customer = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Customer: {{formatDisplayValue(filterSettings.customer)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.poNumber" removable (removed)="filterSettings.poNumber = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">PO: {{formatDisplayValue(filterSettings.poNumber)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.salesManager" removable (removed)="filterSettings.salesManager = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Sales: {{formatDisplayValue(filterSettings.salesManager)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.technicalEngineer" removable (removed)="filterSettings.technicalEngineer = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Project Manager: {{formatDisplayValue(filterSettings.technicalEngineer)}}</span> <!-- Labels reversed from AX -->
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.projectManager" removable (removed)="filterSettings.projectManager = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Project Engineer: {{formatDisplayValue(filterSettings.projectManager)}}</span> <!-- Labels reversed from AX -->
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.planner" removable (removed)="filterSettings.planner = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Planner: {{formatDisplayValue(filterSettings.planner)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.mechanicalEngineer" removable (removed)="filterSettings.mechanicalEngineer = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Mechanical Engineer: {{formatDisplayValue(filterSettings.mechanicalEngineer)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.mechanicalDrafter" removable (removed)="filterSettings.mechanicalDrafter = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Mechanical Drafter: {{formatDisplayValue(filterSettings.mechanicalDrafter)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.electricalEngineer" removable (removed)="filterSettings.electricalEngineer = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Electrical Engineer: {{formatDisplayValue(filterSettings.electricalEngineer)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.electricalDrafter" removable (removed)="filterSettings.electricalDrafter = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Electrical Drafter: {{formatDisplayValue(filterSettings.electricalDrafter)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.activity" removable (removed)="filterSettings.activity = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Activity: {{formatDisplayValue(filterSettings.activity)}}</span>
      </mat-chip>
      <mat-chip class="geaui-chip" *ngIf="filterSettings.status" removable (removed)="filterSettings.status = ''; saveFilterSettings(); onChange()">
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">Status: {{formatDisplayValue(filterSettings.status)}}</span>
      </mat-chip>
      <mat-chip
        class="geaui-chip"
        *ngIf="filterSettings.poStartDate || filterSettings.poEndDate"
        removable
        (removed)="filterSettings.poStartDate = null; filterSettings.poEndDate = null; saveFilterSettings(); onChange()"
      >
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">
          PO Date:
          <ng-container *ngIf="filterSettings.poStartDate && !filterSettings.poEndDate"> &gt;= {{filterSettings.poStartDate | date:'shortDate'}}</ng-container>
          <ng-container *ngIf="!filterSettings.poStartDate && filterSettings.poEndDate"> &lt;= {{filterSettings.poEndDate | date:'shortDate'}}</ng-container>
          <ng-container *ngIf="filterSettings.poStartDate && filterSettings.poEndDate"> {{filterSettings.poStartDate | date:'shortDate'}} - {{filterSettings.poEndDate | date:'shortDate'}}</ng-container>
        </span>
      </mat-chip>
      <mat-chip
        class="geaui-chip"
        *ngIf="filterSettings.shipStartDate || filterSettings.shipEndDate"
        removable
        (removed)="filterSettings.shipStartDate = null; filterSettings.shipEndDate = null; saveFilterSettings(); onChange()"
      >
        <span class="filter-chip-button"><button matChipRemove><span class="material-icons gea-blue">close</span></button></span>
        <span class="filter-chip-text">
          Ship Date:
          <ng-container *ngIf="filterSettings.shipStartDate && !filterSettings.shipEndDate"> &gt;= {{filterSettings.shipStartDate | date:'shortDate'}}</ng-container>
          <ng-container *ngIf="!filterSettings.shipStartDate && filterSettings.shipEndDate"> &lt;= {{filterSettings.shipEndDate | date:'shortDate'}}</ng-container>
          <ng-container *ngIf="filterSettings.shipStartDate && filterSettings.shipEndDate"> {{filterSettings.shipStartDate | date:'shortDate'}} - {{filterSettings.shipEndDate | date:'shortDate'}}</ng-container>
        </span>
      </mat-chip>
      <mat-chip class="reset-filter" *ngIf="filterSettings.showResetAll()" removable (removed)="resetAllFilters()">
        <span class="filter-chip-text" style="cursor: pointer;" (click)="resetAllFilters()">Reset All</span>
        <button matChipRemove><span class="material-icons gea-blue">replay</span></button>
      </mat-chip>
    </mat-chip-set>
  </div>

  <div *ngIf="filterMenuVisible" class="context-menu" [style.top.px]="filterMenuPosition.y" [style.left.px]="filterMenuPosition.x" (click)="hideMultiSelect()">
    <div class="modal-dialog">
      <h2>Projects</h2>
  
      <table>
        <tr>
          <td width="40%" style="vertical-align: top;">

            <label>
              <span class="project-filter-label">Status</span>
              <multi-select-dropdown 
                type="Status"
                [getCustomOptions]="getStatusOptions"
                [value]="tempFilterSettings.status"
                (valueChanged)="tempFilterSettings.status = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Product</span>
              <multi-select-dropdown 
                type="Product"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.product"
                (valueChanged)="tempFilterSettings.product = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Project</span>
              <multi-select-dropdown 
                type="Project"
                [showSearch]="true"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.project"
                (valueChanged)="tempFilterSettings.project = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">End User</span>
              <multi-select-dropdown 
                type="EndUser"
                [showSearch]="true"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.endUser"
                (valueChanged)="tempFilterSettings.endUser = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Customer</span>
              <multi-select-dropdown 
                type="Customer"
                [showSearch]="true"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.customer"
                (valueChanged)="tempFilterSettings.customer = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">PO Number</span>
              <span class="input-container">
                <input type="text" class="custom-input" [(ngModel)]="tempFilterSettings.poNumber" />
                <div class="underline"></div>
              </span>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Activity</span>
              <multi-select-dropdown 
                type="Activity"
                [showSearch]="true"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.activity"
                (valueChanged)="tempFilterSettings.activity = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">PO Date</span>
              <span class="date-range-container">
                <input
                  type="date"
                  class="date-range-input"
                  [class.date-range-input-empty]="!tempFilterSettings.poStartDate"
                  [ngModel]="toDateInputValue(tempFilterSettings.poStartDate)"
                  (ngModelChange)="tempFilterSettings.poStartDate = fromDateInputValue($event)"
                />
                <span class="date-range-separator">-</span>
                <input
                  type="date"
                  class="date-range-input"
                  [class.date-range-input-empty]="!tempFilterSettings.poEndDate"
                  [ngModel]="toDateInputValue(tempFilterSettings.poEndDate)"
                  (ngModelChange)="tempFilterSettings.poEndDate = fromDateInputValue($event)"
                />
              </span>
            </label>
            <br />

            <label>
              <span class="project-filter-label">Ship Date</span>
              <span class="date-range-container">
                <input
                  type="date"
                  class="date-range-input"
                  [class.date-range-input-empty]="!tempFilterSettings.shipStartDate"
                  [ngModel]="toDateInputValue(tempFilterSettings.shipStartDate)"
                  (ngModelChange)="tempFilterSettings.shipStartDate = fromDateInputValue($event)"
                />
                <span class="date-range-separator">-</span>
                <input
                  type="date"
                  class="date-range-input"
                  [class.date-range-input-empty]="!tempFilterSettings.shipEndDate"
                  [ngModel]="toDateInputValue(tempFilterSettings.shipEndDate)"
                  (ngModelChange)="tempFilterSettings.shipEndDate = fromDateInputValue($event)"
                />
              </span>
            </label>
            <br />
  
          </td>
          <td width="40%" style="vertical-align: top;">
  
            <label>
              <span class="project-filter-label">Sales Manager</span>
              <multi-select-dropdown 
                type="SalesManager"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.salesManager"
                (valueChanged)="tempFilterSettings.salesManager = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Project Manager</span> <!-- labels reversed from AX -->
              <multi-select-dropdown 
                type="TechnicalEngineer"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.technicalEngineer"
                (valueChanged)="tempFilterSettings.technicalEngineer = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Project Engineer</span> <!-- labels reversed from AX -->
              <multi-select-dropdown 
                type="ProjectManager"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.projectManager"
                (valueChanged)="tempFilterSettings.projectManager = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Planner</span>
              <multi-select-dropdown 
                type="Planner"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.planner"
                (valueChanged)="tempFilterSettings.planner = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Mechanical Engineer</span>
              <multi-select-dropdown 
                type="MechanicalEngineer"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.mechanicalEngineer"
                (valueChanged)="tempFilterSettings.mechanicalEngineer = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Mechanical Drafter</span>
              <multi-select-dropdown 
                type="MechanicalDrafter"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.mechanicalDrafter"
                (valueChanged)="tempFilterSettings.mechanicalDrafter = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Electrical Engineer</span>
              <multi-select-dropdown 
                type="ElectricalEngineer"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.electricalEngineer"
                (valueChanged)="tempFilterSettings.electricalEngineer = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
            <label>
              <span class="project-filter-label">Electrical Drafter</span>
              <multi-select-dropdown 
                type="ElectricalDrafter"
                [getOptions]="getOptions"
                [value]="tempFilterSettings.electricalDrafter"
                (valueChanged)="tempFilterSettings.electricalDrafter = $event">
              </multi-select-dropdown>
            </label>
            <br />
  
  
          </td>
        </tr>
      </table>
      <br />
      <div style="text-align: right;">
        <button class="geaui-button-primary" (click)="commitTempFilterSettings(); onChange()">Apply</button> &nbsp;
        <button class="geaui-button-secondary" (click)="closeFilterMenu()">Cancel</button>
      </div>
    </div>
  </div>